import { postTrackingBatch } from "./client";
import { getTrackingSchemaVersion } from "./config";
import { safeReadSessionJson, safeWriteSessionJson } from "./storage";

const PENDING_KEY = "tracking.impressions.pending.v1";

const readPending = () => {
  const value = safeReadSessionJson(PENDING_KEY, []);
  return Array.isArray(value) ? value : [];
};

const writePending = (events) => {
  safeWriteSessionJson(PENDING_KEY, events);
};

let pending = readPending();
let flushTimer = null;
let pausedUntilMs = 0;

const MAX_PENDING = 500;
const FLUSH_INTERVAL_MS = 4000; // 3–5s
const FLUSH_BATCH_SIZE = 15; // 10–15

const scheduleFlush = () => {
  if (flushTimer) return;
  flushTimer = window.setTimeout(() => {
    flushTimer = null;
    flushNow();
  }, FLUSH_INTERVAL_MS);
};

export const flushNow = async () => {
  if (!pending.length) return;

  const now = Date.now();
  if (pausedUntilMs && now < pausedUntilMs) {
    scheduleFlush();
    return;
  }

  const chunk = pending.slice(0, FLUSH_BATCH_SIZE);

  const res = await postTrackingBatch({
    schemaVersion: getTrackingSchemaVersion(),
    events: chunk,
  });

  if (res.ok) {
    pending = pending.slice(chunk.length);
    writePending(pending);
    if (pending.length) scheduleFlush();
    return;
  }

  if (res.status === 429) {
    const retryAfterMs = res.retryAfterMs ?? 5000;
    const jitter = Math.floor(Math.random() * 0.2 * retryAfterMs);
    pausedUntilMs = Date.now() + retryAfterMs + jitter;
    scheduleFlush();
    return;
  }

  // Non-retryable or network error: keep pending but avoid tight loop.
  const fallbackPause = 5000;
  pausedUntilMs = Date.now() + fallbackPause;
  scheduleFlush();
};

export const enqueueImpression = (event) => {
  if (!event) return;

  pending = readPending();
  pending.push(event);

  if (pending.length > MAX_PENDING) {
    // Drop oldest impressions (best effort)
    pending = pending.slice(pending.length - MAX_PENDING);
  }

  writePending(pending);

  if (pending.length >= 10) {
    flushNow();
    return;
  }

  scheduleFlush();
};
